import { apiGetAuthorizeCode } from '@ms/shared/services/api/auth'
import { getApiErrorMessage } from './api/error'
import { getAuthSession } from './auth_storage'

const redirectToSocial = async (targetGroupId, { targetPage } = {}) => {
	const response = await apiGetAuthorizeCode(process.env.REACT_APP_SOCIAL_APP_CODE)
	const authorizeCode = response?.data?.authorize_code

	if (!authorizeCode) {
		const error = new Error('ไม่สามารถสร้างรหัสเข้าใช้งาน Social ได้')
		error.response = response
		error.message = getApiErrorMessage(error, error.message)
		throw error
	}

	// A mobile sign-in uses the same one-time Social code as the web handoff.
	// Only a fixed app scheme is allowed; never accept a redirect URL from input.
	const mobileState = sessionStorage.getItem('ms2_mobile_auth_state')
	if (mobileState && /^[a-f0-9]{64}$/.test(mobileState)) {
		sessionStorage.removeItem('ms2_mobile_auth_state')
		const mobileUrl = new URL('ms2mobile://auth/callback')
		mobileUrl.searchParams.set('authorize_code', authorizeCode)
		mobileUrl.searchParams.set('state', mobileState)
		window.location.replace(mobileUrl.toString())
		return
	}

	const { token, expiresAt } = getAuthSession()
	const auth = btoa(JSON.stringify({ token, expire: expiresAt }))
	const redirectUrl = new URL(process.env.REACT_APP_SOCIAL_URL, window.location.origin)

	redirectUrl.searchParams.set('authorize_code', authorizeCode)
	redirectUrl.searchParams.set('auth', auth)
	if (targetGroupId) {
		redirectUrl.searchParams.set('target_group_id', targetGroupId)
	}
	if (targetGroupId && targetPage) {
		redirectUrl.searchParams.set('target_page', targetPage)
	}

	window.location.replace(redirectUrl.toString())
}

export { redirectToSocial }
